// 工程とタスクの追加・編集モーダルで利用する共通処理をまとめる
import { getMerchandiseOrderList } from '../apicalls/merchandiseOrder';
import { getOutSourceList } from '../apicalls/outsource';
import { getSiteProcessNameList } from '../apicalls/process';
import { TSelectItem } from '../types/common';
import { TSiteProcessNameListData } from '../types/process';
import { checkResData } from './common';
import { getConstructionDetails } from '../apicalls/construction';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import { TConstructionDetailAssignee } from '../types/process';
import { EMPLOYEE_STATUS } from '../const/Const';

// 文字列の数値化
export const parseNumber = (value?: string | null) => {
  if (value === undefined) return null;
  if (value === null) return null;
  if (value === '') return null;
  // 10進数以外の表現を受け付けないようにする
  const pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/;
  if (!pattern.test(value)) return null;
  return Number(value);
};

// 発注書の表示形式を作る
export const createSiteTaskFormOrderDisplayName = (order: any) => {
  if (!order) {
    return '--';
  }
  return `${order.code ?? ''}-${order.order_date ?? ''}-${order.partner ?? ''}`;
};

// 外注発注リストの作成
export const createSiteTaskFormOutSourceOrderList: (
  enqueueSnackbar: any
) => Promise<Array<TSelectItem>> = (enqueueSnackbar: any) => {
  return new Promise(resolve => {
    getOutSourceList(
      0,
      '',
      '',
      0,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      0,
      0,
      null,
      null,
      null,
      null
    ).then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        let list: TSelectItem[] = [];
        list.push({ value: 0, label: '--' });
        if (data) {
          const orderList: any = data.data;
          if (orderList && orderList.length > 0) {
            list = list.concat(
              orderList.map((order: any) => {
                return {
                  value: order.id,
                  label: createSiteTaskFormOrderDisplayName(order)
                };
              })
            );
          }
        }
        resolve(list);
      });
    });
  });
};

// 商品発注リストの作成
export const createSiteTaskFormMerchandiseOrderList: (
  enqueueSnackbar: any
) => Promise<Array<TSelectItem>> = (enqueueSnackbar: any) => {
  return new Promise(resolve => {
    getMerchandiseOrderList(
      0,
      '',
      0,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      0,
      0,
      null,
      null,
      null,
      null
    ).then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        let list: TSelectItem[] = [];
        list.push({ value: 0, label: '--' });
        if (data) {
          const orderList: any = data.data;
          if (orderList && orderList.length > 0) {
            list = list.concat(
              orderList.map((order: any) => {
                return {
                  value: order.id,
                  label: createSiteTaskFormOrderDisplayName(order)
                };
              })
            );
          }
        }
        resolve(list);
      });
    });
  });
};

// 工程リストの作成
export const createSiteTaskFormProcessListPulldown: (
  constructId: number,
  enqueueSnackbar: any
) => Promise<Array<TSelectItem>> = (
  constructId: number,
  enqueueSnackbar: any
) => {
  return new Promise(resolve => {
    getSiteProcessNameList(constructId, false).then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        let list: TSelectItem[] = [];
        list.push({ value: 0, label: '--' });
        if (data) {
          const siteProcessList: TSiteProcessNameListData[] = data.data;
          if (siteProcessList && siteProcessList.length > 0) {
            list = list.concat(
              siteProcessList.map((siteProcess: TSiteProcessNameListData) => ({
                value: siteProcess.id,
                label:
                  (siteProcess.parent_site_process_id ? '　' : '') +
                    siteProcess.site_process_name ?? ''
              }))
            );
          }
        }
        resolve(list);
      });
    });
  });
};

/**
 * 工程の新規登録・編集とタスクの新規登録・編集で利用する担当者一覧を作成する
 */
export const createSiteProcessAndSiteTaskEmployeeList: (
  constructId: number,
  enqueueSnackbar: any,
  placeholder?: string
) => Promise<Array<TSelectItem>> = (
  constructId: number,
  enqueueSnackbar: any,
  placeholder: string = '--'
) => {
  // 担当者選択プルダウンの一番上を工事担当者にするように担当者一覧を作る
  return new Promise(resolve => {
    let list: Array<TSelectItem> = [];
    if (constructId > 0) {
      // 工事アサイン者を取得
      getConstructionDetails(constructId).then(resData => {
        checkResData(resData, enqueueSnackbar).then(data => {
          if (data) {
            const constructionDetailAssigneeList = data?.data?.assignee_list;
            const assigneeUserIdList: Array<number> = [];
            if (constructionDetailAssigneeList) {
              constructionDetailAssigneeList.map(
                (constructionDetailAssignee: TConstructionDetailAssignee) => {
                  assigneeUserIdList.push(
                    constructionDetailAssignee.assignee_user
                  );
                }
              );
            }

            // 担当者一覧を取得
            getEmployeeMasterList('', 1).then((resData: any) => {
              checkResData(resData, enqueueSnackbar).then((data: any) => {
                if (data) {
                  // 無効化アカウントをリストから排除する
                  const employeeList = data.data;
                  if (employeeList && employeeList.length > 0) {
                    list.push({ value: 0, label: placeholder });
                    // 工事に紐づく担当者を先頭にする
                    list = list.concat(
                      employeeList
                        .filter((employee: any) =>
                          assigneeUserIdList.includes(employee.id)
                        )
                        .map((employee: any) => ({
                          value: employee.id,
                          label: employee.name ?? ''
                        }))
                    );
                    // それ以外の担当者
                    list = list.concat(
                      employeeList
                        .filter(
                          (employee: any) =>
                            !assigneeUserIdList.includes(employee.id) &&
                            employee.status !== EMPLOYEE_STATUS.INACTIVE
                        )
                        .map((employee: any) => ({
                          value: employee.id,
                          label: employee.name ?? ''
                        }))
                    );
                    resolve(list);
                  }
                }
              });
            });
          }
        });
      });
    } else {
      resolve(list);
    }
  });
};

// 工程追加・編もモーダルで利用する工程一覧プルダウンのリスト作成
export const createSiteProcessFormProcessListPulldown: (
  constructId: number,
  enqueueSnackbar: any
) => Promise<Array<TSelectItem>> = (
  constructId: number,
  enqueueSnackbar: any
) => {
  return new Promise(resolve => {
    getSiteProcessNameList(constructId, true).then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        let list: TSelectItem[] = [];
        list.push({ value: 0, label: '--' });
        if (data) {
          const siteProcessList: TSiteProcessNameListData[] = data.data;
          if (siteProcessList && siteProcessList.length > 0) {
            list = list.concat(
              siteProcessList.map((siteProcess: TSiteProcessNameListData) => ({
                value: siteProcess.id,
                label: siteProcess.site_process_name ?? ''
              }))
            );
          }
        }
        resolve(list);
      });
    });
  });
};

// APIから取得したユーザーデータをセレクトボックス用に展開
export const getUserSelectOptions = (userData: any[]) => {
  return userData
    .filter((i: any) => i.status !== EMPLOYEE_STATUS.INACTIVE)
    .map((i: any) => <option value={i.id}>{i.name}</option>);
};
